<template>
  <div class="back-head">
    <img src="../assets/img/homeLogo.png" alt="">
    <div class="right" @click="setLange"><img src="../assets/img/qiub.png" alt="">{{ $store.state.languageName }}</div>
  </div>
</template>

<script>
export default {
  name: 'backHead',
  props: {},
  methods: {
    back() {
      this.$router.go(-1)
    },
    setLange() {
      this.$store.commit('changeIsShow', true);
    }
  }
}
</script>
<style scoped lang="scss">
.back-head {
  height: 50px;
  // width: 600px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  margin-bottom: 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  border-bottom: 1px solid rgba(0, 40, 63, 0.10);
  backdrop-filter: blur(25px);

  img {
    width: 149px;
    height: 32px;
    margin-bottom: -1px;
  }

  .right {
    color: #0866FF;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;

    img {
      width: 18px;
      height: 18px;
      margin-right: 5px;
    }
  }
}
</style>
